import { combineReducers } from 'redux'
import JobReducer from './job/reducer'
import UserReducer from './user/reducer'
import NoteReducer from './note/reducer'
import DashboardReducer from './dashboard/reducer';
import PermissionReducer from './permission/reducer';

const rootReducer = combineReducers({
    JobReducer,
    UserReducer,
    NoteReducer,
    DashboardReducer,
    PermissionReducer
});

export default rootReducer